import { Building2, Hospital, Pill } from 'lucide-react'
import { useTranslation } from 'react-i18next'
import type { GeoPosition } from '../../shared/hooks/useGeolocation'

interface LiveEmergencyBlockProps {
  position: GeoPosition | null
}

export function LiveEmergencyBlock({ position }: LiveEmergencyBlockProps) {
  const { t } = useTranslation()

  const shortcuts = [
    {
      label: t('live.pharmacy'),
      icon: <Pill className="h-5 w-5" />,
      query: 'pharmacy near me',
      color: 'text-green-700 bg-green-50 border-green-200',
    },
    {
      label: t('live.hospital'),
      icon: <Hospital className="h-5 w-5" />,
      query: 'hospital emergency room near me',
      color: 'text-red-700 bg-red-50 border-red-200',
    },
    {
      label: t('live.embassy'),
      icon: <Building2 className="h-5 w-5" />,
      query: 'embassy consulate near me',
      color: 'text-blue-700 bg-blue-50 border-blue-200',
    },
  ]

  function buildUrl(query: string): string {
    if (position) {
      return `https://www.google.com/maps/search/${encodeURIComponent(query)}/@${position.lat},${position.lng},14z`
    }
    return `https://www.google.com/maps/search/${encodeURIComponent(query)}`
  }

  return (
    <section aria-labelledby="emergency-heading" className="border-t border-st-line pt-4">
      <h3
        id="emergency-heading"
        className="mb-3 text-xs font-semibold uppercase tracking-wide text-st-muted"
      >
        {t('live.emergency')}
      </h3>
      <div className="grid grid-cols-3 gap-2">
        {shortcuts.map(({ label, icon, query, color }) => (
          <a
            key={label}
            href={buildUrl(query)}
            target="_blank"
            rel="noopener noreferrer"
            className={`flex flex-col items-center gap-1.5 rounded-st-md border px-2 py-3 text-center text-xs font-medium transition hover:opacity-80 active:scale-95 ${color}`}
          >
            {icon}
            {label}
          </a>
        ))}
      </div>
    </section>
  )
}
